import React from 'react';
import { useNavigate } from 'react-router-dom';

const Home = ({ user }) => {
  const navigate = useNavigate();

  return (
    <div className="hero">
      <img src="/NightBacon.png" alt="Night Bacon" className="hero-image" />
      <div className="hero-content">
        <h1 className="hero-title">Night Bacon Portal</h1>
        <p className="hero-subtitle">
          A collaborative space for band members to share and work on music together.
        </p>
        {user ? (
          <button onClick={() => navigate('/files')}>Go to Files</button>
        ) : (
          <button onClick={() => navigate('/login')}>Sign In</button>
        )}
      </div>
    </div>
  );
};

export default Home;
